import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Input from 'components/commons/Input';
import Button from 'components/commons/Button';

import mercadoPagoImage from 'views/Checkout/assets/mercado-pago.png';

import truckImage from './assets/truck.png';

import './PaymentForm.scss';

const validate = (values) => {
  const errors = {};
  if (!values.delivery_method) {
    errors.delivery_method = 'Debe elegir un método de envío';
  }
  return errors;
};

const formatMoney = (value) => `$${Number(value || 0).toLocaleString('es-AR')}`;

const getShippingHint = (envio) => {
  if (envio?.arrange_with_seller) {
    return 'Coordinás precio y forma de entrega con el vendedor.';
  }
  if (Number(envio?.monto_minimo) > 0) {
    return `Envío gratis superando ${formatMoney(envio.monto_minimo)}.`;
  }
  if (Number(envio?.monto) > 0) {
    return `Costo de envío: ${formatMoney(envio.monto)}.`;
  }
  if (envio?.calculated_by_system) {
    return 'El sistema calcula el costo según tu dirección.';
  }
  return 'Disponible para este pedido.';
};

const PaymentForm = (props) => {
  const {
    deliveryMethod, handleSubmit, onSubmit, submitting, onSecureCheckoutClick, showMPButton,
    envios, hayAcuerdoConVendedor, canPay,
  } = props;

  const enviosSafe = Array.isArray(envios) ? envios : [];

  return (
    <div className="container checkout-step checkout-step--payment" data-testid="payment-form">
      <div className="row">
        <div className="form-container">
          <div className="checkout-section-header">
            <div>
              <span className="checkout-section-kicker">Paso 2</span>
              <h3 className="checkout-section-title">Envío y pago</h3>
              <div className="checkout-section-subtitle">
                Elegí cómo recibir el pedido y después confirmá el pago.
              </div>
            </div>
          </div>

          {!canPay && (
            <div className="checkout-inline-warning" role="status">
              Completá los datos del paso 1 para habilitar estas opciones.
            </div>
          )}

          <form className="redux-form" encType="multipart/form-data" onSubmit={handleSubmit(onSubmit)}>
            <div className="checkout-shipping-options">
              {enviosSafe.length > 0 ? enviosSafe.map((envio) => (
                <div key={envio.id} className="checkout-radio">
                  <Field
                    formGroupClassName={parseInt(deliveryMethod, 10) === envio.id ? 'radio-active' : ''}
                    name="delivery_method"
                    label=""
                    component={Input}
                    type="radio"
                    value={envio.id.toString()}
                    renderRadioDiv={() => (
                      <div className="radio-button-info">
                        <div className="radio-button-image">
                          <img src={truckImage} className="truck-image" alt="" />
                        </div>
                        <div className="radio-button-text">
                          <span className="radio-button-title">{envio.name}</span>
                          <span className="radio-span-subtitle">{getShippingHint(envio)}</span>
                        </div>
                      </div>
                    )}
                  />
                </div>
              )) : (
                <div className="checkout-inline-warning" role="status">
                  Todavía no hay métodos de envío disponibles para esta tienda.
                </div>
              )}
            </div>

            <div className="checkout-logistics-link">
              Logística gestionada por la tienda.
            </div>

            <Field
              component={Input}
              label="Comentarios para el vendedor"
              isTextArea
              name="comments"
            />

            <div className="checkout-pay-actions">
              {!!hayAcuerdoConVendedor && (
                <Button
                  text="Arreglar pago con el vendedor"
                  type="submit"
                  buttonClass="btn-block checkout-secondary-action"
                  disabled={!canPay || submitting}
                />
              )}

              {showMPButton && (
                <Button
                  text={(
                    <div className="secure-checkout-button-content justify-content-center">
                      <img src={mercadoPagoImage} alt="Mercado Pago" height="18" />
                      <span>Pagá con tarjeta de crédito o débito</span>
                    </div>
                  )}
                  type="button"
                  onClick={handleSubmit(onSecureCheckoutClick)}
                  buttonClass="btn-block secure-checkout-button"
                  disabled={!canPay || submitting}
                />
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

PaymentForm.defaultProps = {
  deliveryMethod: null,
  canPay: true,
  envios: [],
  onSecureCheckoutClick: () => { },
  showMPButton: false,
  hayAcuerdoConVendedor: false,
};

PaymentForm.propTypes = {
  deliveryMethod: PropTypes.string,
  envios: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    monto: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    monto_minimo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    arrange_with_seller: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    calculated_by_system: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  })),
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onSecureCheckoutClick: PropTypes.func,
  showMPButton: PropTypes.bool,
  canPay: PropTypes.bool,
  hayAcuerdoConVendedor: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default reduxForm({
  form: 'payment',
  validate,
})(PaymentForm);
